import { get, post } from "../../helpers/utils/http-client";
import {APPS_ENDPOINT, CONFIGS_ENDPOINT} from '../../consts/api-endpoints';


export async function fileUploadUrlGet(appId, request) {
    return await post(`${APPS_ENDPOINT}/${appId}/contents/upload-url-gen`, request);
}

export async function fileUpload(preSignedUrl, file) {
    try {
        const headers = new Headers();
        const requestOptions = {
            method: 'PUT',
            body: file,
            redirect: 'follow',
            headers,
        };
        return await fetch(preSignedUrl, requestOptions)
    } catch (err) {
        console.debug('file upload failed cause', err);
        return null;
    }
}
